export const dashboardMessages = {
    'Dashboard.About': 'About dashboard',
    'Dashboard.About.autoAdjust': 'Auto Adjust',
    'Dashboard.About.context': 'Context',
    'Dashboard.About.dashboardId': 'Dashboard ID',
    'Dashboard.About.dashboardVersion': 'Dashboard version',
    'Dashboard.About.dataUpdatedAt': 'Dashboard updated at',
    'Dashboard.About.isFiltrable': 'Is filterable',
    'Dashboard.About.isSearchable': 'Is searchable',
    'Dashboard.About.refreshDashboard': 'Refresh dashboard',
    'Dashboard.filters': 'Filter dashboard',
    'Dashboard.Panel.fullScreen.collapse': 'Collapse panel',
    'Dashboard.Panel.fullScreen.expand': 'Expand panel',
    'Dashboard.Panel.refresh': 'Refresh panel',
    'Dashboard.Panel.settings': 'Panel settings',
    'Dashboard.search': 'Search',
    'Dashboard.settings': 'Dashboard settings',
    'Dashboard.Settings.AutoAdjust': 'Auto Adjust',
    'Dashboard.Settings.Layout': 'Layout',
    'Dashboard.Settings.PauseRefresh': 'Pause refresh',
    'Dashboard.Settings.ResumeRefresh': 'Resume refresh'
};
